import SectionHeader from '@Web/Src/Components/SectionHeader/index.jsx';
import Loading from '@Web/Src/UI/Loading';

const SoftwareAbilitiesLazy = ({
    data,
    title = '',
    desc = '',
    className = '',
    topTitle = false,
    icon = 'atom',
    type = 'dark',
}) => {
    return (
        <div className={`${className} text-dark mx-auto w-full max-w-[1250px]`}>
            <SectionHeader
                topTitle={topTitle}
                className='mx-auto mt-40'
                icon={icon}
                title={title}
                desc={desc}
                type={type}
                iconSize={'size-12'}
            />
            <div className='bg-light medium:block mt-16 flex w-full items-center gap-4 rounded-3xl shadow-[0px_0px_32px_0px_rgba(9,21,57,0.15)]'>
                <div className='medium:p-6 small:!p-4 flex flex-1 flex-col items-center p-10'>
                    <Loading />
                    <div className='hidden'>
                        {data.map((item) => {
                            return (
                                <div key={item.label}>
                                    <p>{item.label}</p>
                                    <p>{item.text}</p>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SoftwareAbilitiesLazy;
